import React from "react";
import { FaPython, FaNode, FaReact, FaDocker, FaAws, FaGithub, FaHtml5, FaCss3Alt, FaGit, FaLinux } from "react-icons/fa";
import { SiDjango, SiFlask, SiFastapi, SiExpress, SiRedux, SiTailwindcss, SiSocketdotio, SiWebrtc, SiJavascript, SiTypescript, SiPostgresql, SiMysql, SiRedis, SiPostman, SiRabbitmq, SiJest, SiVercel, SiNginx, SiCelery, SiMongodb, SiAmazonaws, SiVisualstudiocode } from "react-icons/si";
import { DiSqllite } from "react-icons/di";

// Collect all unique icons you want to show
const skillIcons = [
  <FaPython key="python" />, <FaNode key="node" />, <FaReact key="react" />, <FaDocker key="docker" />, <FaAws key="aws" />, <FaGithub key="github" />, <FaHtml5 key="html5" />, <FaCss3Alt key="css3" />, <FaGit key="git" />, <FaLinux key="linux" />,
  <SiDjango key="django" />, <SiFlask key="flask" />, <SiFastapi key="fastapi" />, <SiExpress key="express" />, <SiRedux key="redux" />, <SiTailwindcss key="tailwind" />, <SiSocketdotio key="socketio" />, <SiWebrtc key="webrtc" />, <SiJavascript key="js" />, <SiTypescript key="ts" />, <SiPostgresql key="postgresql" />, <SiMysql key="mysql" />, <SiRedis key="redis" />, <SiPostman key="postman" />, <SiRabbitmq key="rabbitmq" />, <SiJest key="jest" />, <SiVercel key="vercel" />, <SiNginx key="nginx" />, <SiCelery key="celery" />, <SiMongodb key="mongodb" />, <SiAmazonaws key="amazonaws" />, <SiVisualstudiocode key="vscode" />, <DiSqllite key="sqlite" />
];

const Skills = () => (
  <div>
    <section className="resume-section" id="skills">
      <div className="resume-section-content">
        <h2 className="mb-5">Skills</h2>
        <ul className="list-inline dev-icons" style={{ display: 'flex', flexWrap: 'wrap', gap: '18px' }}>
          {skillIcons.map((icon, idx) => (
            <li className="list-inline-item" key={idx} style={{ minWidth: 48, marginBottom: 8 }}>
              <span style={{ fontSize: 48, verticalAlign: "middle", color: '#ff8c00' }}>{icon}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
    <hr className="m-0" />
  </div>
);

export default Skills;